import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: storeStructure.s3externalResources,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have any video resources, click on the \"+\" icon to add one.",
  fields: [
    
    {
      attributeName: 'bucketName',
      label: 'Bucket Name',
      types: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'External bucket name',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'bucketRegion',
      label: 'Bucket Region',
      types: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'External bucket region',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'videoFileName',
      label: 'File name and extension (complete object key)',
      types: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'File name and extensions',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'cameraName',
      label: 'Camera Name',
      types: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'Name of the corresponding camera',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'accessKey',
      label: 'Access Key (IAM/HMAC)',
      type: FormInputTypes.TEXT_INPUT.STRING,
      helpText: 'Access Key for external bucket',
      default: '',
      canEdit: true,
      canCreate: true,
    },
    {
      attributeName: 'secretKey',
      label: 'Secret Access Key (IAM/HMAC)',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      helpText: 'Secret Key for external bucket',
      default: '',
      canEdit: true,
      canCreate: true,
    }
  ],
};
